var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('level-container',{key:_vm.levelId,staticClass:"c-view-level"})}
var staticRenderFns = []

export { render, staticRenderFns }